import { useTranslation } from "@/contexts/LanguageContext";

const DSLR_IDS = new Set(["sony_a58", "sony_a68", "sony_a77_ii", "sony_a99ii", "fujifilm_s5pro", "fujifilm_s3pro"]);

export const cameraType = (id) => {
  if (id === "custom") return "any";
  if (id.startsWith("film_")) return "film";
  if (id === "nikon_coolpix_p100") return "compact";
  if (DSLR_IDS.has(id) || id.startsWith("nikon_d") || id.startsWith("pentax_")) return "dslr";
  if (id.startsWith("canon_eos_r") && !id.startsWith("canon_eos_rebel")) return "mirrorless";
  if (id.startsWith("canon_")) return "dslr";
  return "mirrorless";
};

const LABELS = {
  dslr: { en: "DSLR", es: "DSLR", cls: "text-sky-300 border-sky-400/30 bg-sky-400/10" },
  mirrorless: { en: "Mirrorless", es: "Mirrorless", cls: "text-emerald-300 border-emerald-400/30 bg-emerald-400/10" },
  film: { en: "Film", es: "Película", cls: "text-[#F5A524] border-[#F5A524]/30 bg-[#F5A524]/10" },
  compact: { en: "Compact", es: "Compacta", cls: "text-[#A1A1AA] border-white/15 bg-white/5" },
};

export const CameraTypeTag = ({ cameraId, testId }) => {
  const { lang } = useTranslation();
  const l = LABELS[cameraType(String(cameraId))];
  if (!l) return null;
  return (
    <span
      className={`inline-block shrink-0 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${l.cls}`}
      data-testid={testId || `camera-type-tag-${cameraId}`}
    >
      {lang === "es" ? l.es : l.en}
    </span>
  );
};
